     <ng-container *ngIf="user">
       <div class="userSidenavItem sidenavItem notAButton">
         <div class="userImage">
           <img [src]="user.id | toString | authImgSource: userImageProviderService | async">
         </div>
         <div class="sidenavItemInfo">
           <span class="sidenavUsername">{{user.displayName}}</span>
         </div>
       </div>
     </ng-container>
